import * as React from "react";
const SvgFiRrTransformationCircle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-transformation-circle_svg__a)">
      <path
        fill="#062147"
        d="M17.995 5h-3.262a.731.731 0 0 0-.517 1.249l1.061 1.061-1.522 1.522A8.45 8.45 0 0 0 8.501 7C3.813 7 0 10.813 0 15.5S3.813 24 8.5 24s8.5-3.813 8.5-8.5a8.45 8.45 0 0 0-1.832-5.254l1.522-1.522 1.061 1.061A.732.732 0 0 0 19 9.268V6.006C19 5.451 18.55 5 17.995 5M8.5 22A6.51 6.51 0 0 1 2 15.5C2 11.916 4.916 9 8.5 9s6.5 2.916 6.5 6.5S12.084 22 8.5 22M24 8.5a8.44 8.44 0 0 1-3.399 6.8 1.001 1.001 0 0 1-1.401-.199 1 1 0 0 1 .199-1.4A6.45 6.45 0 0 0 22 8.501C22 4.917 19.084 2 15.5 2a6.45 6.45 0 0 0-5.201 2.601A1 1 0 0 1 8.7 3.401 8.44 8.44 0 0 1 15.5.002c4.687 0 8.5 3.813 8.5 8.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-transformation-circle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTransformationCircle;
